import { ColorName } from '~/models/Content/Color'

export function getColor(colorName: ColorName): string {
  return `var(--color-${colorName})`
}

export function getColorAndShade(baseColorName: any, shade: '5' | '10' | '20' | '30' | '40' | '50' | '60' | 'pop'): string {
  let colorString: string
  if (baseColorName.startsWith('var(--color-')) {
    colorString = baseColorName.replace('var(--color-', '').replace(')', '')
  } else {
    colorString = baseColorName
  }

  const baseColor = colorString.split('-')[0]
  return `var(--color-${baseColor}-${shade})`
}

export const colorMap = new Map<ColorName, string>(
  Object.values(ColorName).map(colorName => [
    colorName,
    getColor(colorName)
  ])
)

export function getBaseColorName(input: string): string {
  if (!input)
    return ''
  let token = input.trim()

  if (token.startsWith('var(') && token.endsWith(')')) {
    token = token.slice(4, -1) // -> --color-xxx
  }
  if (token.startsWith('--color-')) {
    token = token.slice('--color-'.length) // -> xxx or xxx-yy
  }

  return token.split('-')[0] || ''
}

export function colorIsLight(color: string) {
  let r, g, b: number
  if (color.charAt(0) === '#') {
    const colorHex = +(`0x${color.slice(1)}`)
    if (color.length < 5) {
      colorHex.toString().replace(/./g, '$&$&')
    }
    r = colorHex >> 16
    g = colorHex >> 8 & 255
    b = colorHex & 255
  } else {
    const splitColor = color.split(' ')
    r = Number(splitColor[0])
    g = Number(splitColor[1])
    b = Number(splitColor[2])
  }

  const hsp = Math.sqrt(
    0.299 * (r * r)
    + 0.587 * (g * g)
    + 0.114 * (b * b),
  )

  return (hsp > 127.5)
}

export const colors: string[] = (() => {
  const ret: string[] = []
  const colorList = ['orange', 'coral', 'violet', 'purple', 'blue', 'seagreen', 'green']
  colorList.forEach((color) => {
    [5, 10, 20, 'pop'].forEach((shade) => {
      ret.push(`var(--color-${color}-${shade})`)
    })
  })
  return ret
})()

export const getColorForId = (_id: string | number, colors: string[]) => {
  const id = String(_id)
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    const char = id.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash |= 0
  }
  const index = Math.abs(hash) % colors.length
  return colors[index]
}

export const forceColorShade = (color: string, shade: '5' | '10' | '20' | '30' | '40' | 'pop' | '50' | '60') => {
  let colorName: string

  if (color.startsWith('var(--color-')) {
    colorName = color.replace('var(--color-', '').replace(')', '').split('-')[0]
  } else if (color.startsWith('--color-')) {
    colorName = color.replace('--color-', '').split('-')[0]
  } else {
    colorName = color.split('-')[0]
  }

  return `var(--color-${colorName}-${shade})`
}

export const popThisColor = (color: string): string => forceColorShade(color, 'pop')
